module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "No1 The Goodsyard",
    url: process.env.ELEVENTY_ENV === 'dev' ? 'https://develop--coplan-portsmouth.netlify.app' : 'https://thegoodsyard.site',

    holding: {
        "brand": "/assets/images/Brand/CMYK_Neg.svg",
        "message": "Website coming soon"
    },

    base: {
        "contact_address": "RTBU-HAYY-LCUX 7 Bayley Street, London WC1B 3HB (no stamp needed)",
        "contact_number": "020 7323 3544",
        "contact_email": "consultation@thegoodsyard.site"
    },

    meta: {
        "defaultSocialImage": "/assets/images/social.jpg",
        "author": "",
        "description": "",
        "gtag": "G-LHT5PLK1FR",
        "gtm": "GTM-NR94DRPR"
    },

    form: {
        "contact": {
            "catcher_id": "",
            "recaptcha": "",
            "honeypot": ""
        },
        "feedback": {
            "catcher_id": "14482d278919be8630332a1ca29dfe73",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b",
            "honeypot": "44828ca28d29eef2a483dd5de0cdd98e"
        }
    },

    consultation: {
        "feedback_active": false,
        "start_datetime": "",
        "end_datetime": "",
        "closed_message": "This consultation is closed and is no longer accepting feedback.",

        // Consultation close countdown. If set to true, show countdown in site header
        "has_countdown": false,
        "countdown_end": "03/31/2022 23:59:59", // Date format MM/DD/YYYY HH:MM:SS

        "themes": [
            {
                "name": "Development",
                "url": "section-1",
                "feedback_url": '',
                "icon": "marker",
                "question": " Do you support the principle of developing the Matalan car park site for offices and a public square?",
                "key": "01-section"
            },
            {
                "name": "Design",
                "url": "section-2",
                "feedback_url": 'page-2/',
                "icon": "design",
                "question": "Do you have any comments on the proposed office building and its design?",
                "question2": "Do you have any comments on the proposed public square and its design?",
                "key": "02-section"
            },
            {
                "name": "New public square",
                "url": "section-3",
                "feedback_url": 'page-3/',
                "icon": "public-space",
                "question": " Is there anything you would specifically like to see included in the public square (ie art, seating, sculpture, water feature, planting etc)",
                "key": "03-section"
            },
            {
                "name": "Enhancements",
                "url": "section-4",
                "feedback_url": 'page-4/',
                "icon": "visual",
                "question": " Is there anything you think would make the overall proposals better?",
                "key": "04-section"
            },
            {
                "name": "General Comments",
                "url": "section-5",
                "feedback_url": 'page-5/',
                "icon": "uncategorised",
                "question": "Do you have any other comments about the proposals?",
                "key": "05-section"
            }
        ]
    },

    downloads: [
        {
            "title": "Consultation leaflet",
            "url": "/assets/images/pdf/no.1_the_goodsyard_leaflet.pdf"
        },
        {
            "title": "Consultation advertisement",
            "url": "/assets/images/pdf/no.1_the_goodsyard_Advert.pdf"
        }
    ],

    faqs: [
        {
            "question": "Who is going to use the office you’re proposing to build?",
            sections: [
                {
                    "text": "The occupier will be a credible business user.  We’re not able to name them for contractual reasons but it will be a high-quality operator.  This is not a speculative building."
                },
                {
                    "text": "We anticipate that the building be occupied by approximately 600-1,000 people, using the space flexibly and in line with modern approaches to hybrid and flexible working."
                }
            ]
        },
        {
            "question": "Did you consider other uses for this site, for example new homes?",
            sections: [
                {
                    "text": "Yes.  We initially looked at a range of possible uses informed by the site’s location and by local planning policies.  We considered homes, retail, office and mixed-use.  We’re proposing an office use because we think this achieves the best solution for regenerating the site and providing benefit to the city and the local economy.  Putting jobs in the city centre and next to the station makes sense."
                }
            ]
        },
        {
            "question": "Why do you need car parking when the site is right next to the railway station?",
            sections: [
                {
                    "text": "The parking provision (cars and bicycles) is informed by a range of assessments, discussion with the occupier, and relevant planning policy.  We think the proposals provide a good blend of on-site parking together with encouragement for sustainable and active travel choices."
                }
            ]
        },
        {
            "question": "Have you been ambitious enough on carbon and energy? ",
            sections: [
                {
                    "text": "We think so.  We’re targeting BREEAM ‘Outstanding’ for the building which is the highest level ranking.  We’ve considered carbon, energy, materials and all aspects of what goes into the building and how the building would operate very carefully.  This would be one of the greenest buildings in the city."
                }
            ]
        },
        {
            "question": "Will the proposed ‘public square’ actually be for the public?  Or is it private land?",
            sections: [
                {
                    "text": "We’re designing a public square for public use.  Ultimately the land is currently owned in a private capacity but the point is that anyone will be able to use and enjoy the space, so long as they are doing so responsibly and with appropriate regard for others."
                }
            ]
        },
        {
            "question": "When do you hope to have the new office building finished and occupied?",
            sections: [
                {
                    "text": "We’re working towards a target date of summer 2026 for completing the building, ready to hand it over to the occupier."
                }
            ]
        },
        {
            "question": "Will you use local contractors to build it?  Will there be jobs for local construction companies?",
            sections: [
                {
                    "text": "We always look to procure the best and most appropriate contractors for any project.  We would expect to use credible companies and they will either be local or national.  We want this project to deliver local benefits both during construction and once it’s finished, occupied and operating."
                }
            ]
        },
        {
            "question": "What type of planning application will you be submitting and how will it be determined?",
            sections: [
                {
                    "text": "We will submit a detailed planning application to Portsmouth City Council as the local planning authority.  We would anticipate that the Council will take the application to its planning committee for determination."
                }
            ]
        },
        {
            "question": "How will my feedback be used?",
            sections: [
                {
                    "text": "All comments and feedback submitted as part of our public consultation will be considered and used to inform the proposals, potentially helping us to refine or adjust things before we finalise the planning application.  We will prepare a report – a Statement of Community Engagement (SCE) – which will be submitted as part of the planning application.  Your feedback will be used in line with the appropriate GDPR regulations."
                }
            ]
        },
        {
            "question": "What are the plans for the site (of the actual old Matalan store building) alongside this former car park site?  What would come next?",
            sections: [
                {
                    "text": "We’re concentrating on this application for the former car park site at the moment.  The old store building site has the potential to suit a number of complementary uses, including retail, leisure and/or office."
                }
            ]
        },
        {
            "question": "Why is the scheme called ‘The Goodsyard’?",
            sections: [
                {
                    "text": "The site was originally railway sidings and part of a larger Portsmouth & Southsea railway station.  The name is a nod to that railway heritage and the fact that the land was previously used as a goodsyard, serving the station and the city."
                }
            ]
        }
    ],

    hasMap: false,

    // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? '[STAGING LINK]' : '[PROD LINK]',

    // Bugsnag API Key
    bugsnagApiKey: 'dbd6caed1ee917f6c93875317d1084bf',

    // Marker.io Key - replace this default key
    marker_io: '618d2de7be76ee21e8452764',

    // Cookiefirst ID
    cookieFirst: 'thegoodsyard.site-e84ecde7-877e-41ca-9695-2fdd1dff1bbc'
};
